import { Box, VisuallyHidden } from '@chakra-ui/react'
import type { FC } from 'react'
import { useRef } from 'react'
import { useState } from 'react'

import { Button } from '@app/components/ui/button'
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from '@app/components/ui/menu'
import MetricIntegrationDeleteButton from '@app/pages/settings/integrations/components/metricIntegrations/metricIntegrationDeleteButton'
import MetricIntegrationEditModal from '@app/pages/settings/integrations/components/metricIntegrations/metricIntegrationEditModal'
import Can from '@app/shared/authorization/can'
import type { Credential } from '@graphql/types'

interface Props {
  data: Credential
}

const MetricIntegrationsActions: FC<Props> = ({ data }) => {
  const [editOpen, setEditOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(undefined)

  return (
    <Can I="update" a="credential">
      <MetricIntegrationEditModal credential={data} open={editOpen} onOpenChange={(e) => setEditOpen(e.open)} />
      <MetricIntegrationDeleteButton credential={data}>
        <VisuallyHidden>
          <Button ref={buttonRef}>Delete trigger</Button>
        </VisuallyHidden>
      </MetricIntegrationDeleteButton>
      <Box textAlign="end">
        <MenuRoot>
          <MenuTrigger asChild>
            <Button variant="outline">...</Button>
          </MenuTrigger>
          <MenuContent>
            <MenuItem value="edit_integration" aria-label="Edit metric integration" onClick={() => setEditOpen(true)}>
              Edit integration...
            </MenuItem>
            <MenuItem
              value="delete_integration"
              aria-label="Delete metric integration"
              onClick={() => buttonRef?.current?.click()}
            >
              Delete integration...
            </MenuItem>
          </MenuContent>
        </MenuRoot>
      </Box>
    </Can>
  )
}

export default MetricIntegrationsActions
